import api from '../callApi';
import humanparser from 'humanparser';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';
import { relevantRepresentatives } from '../../utils/localRepresentative/parser';

const sendEmailErrorMessage = "Couldn't send email, try again later";

const getErrorMessage = errorList =>
    errorList && errorList.length ? errorList[0] : sendEmailErrorMessage;

const completeEmail = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    representativeSearch,
    emailTopic,
    emailMessage
) => {
    const name = humanparser.parseName(values.fullName);
    const addressParsedNumber = parseAddressNumber(values.address);
    const addressParsedStreet = parseAddressStreet(values.address);
    let representatives =
        localRepData && localRepData.representative
            ? relevantRepresentatives(representativeSearch, localRepData.representative)
            : [];
    representatives = representatives.map(rep => ({
        level: rep.level,
        role: rep.role,
        name: rep.fullName,
        state: rep.state,
        districtNo: rep.districtNo,
        bioguideId: rep.bioguideId
    }));
    let address = {
        source: 1
    };

    if (representatives.length) {
        address = {
            source: localRepData.isUserInput || Object.keys(values).length > 5 ? 0 : 1, // source: 0 = user input
            country: 'US',
            state: values.stateId || localRepData.address.state,
            county: values.county,
            city: values.homeCity || localRepData.address.city,
            zipCode: values.postalCode || localRepData.address.zipCode,
            street: addressParsedStreet || localRepData.address.street,
            streetNo: addressParsedNumber || localRepData.address.streetNo
        };
    }

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,

        from: values.email,
        firstName: name.middleName
            ? name.firstName + ' ' + name.middleName
            : name.firstName,
        lastName: name.lastName || name.suffix,
        prefix: values.prefix,
        text: emailMessage || values.message,
        notifyResult: values.getUpdates,

        representatives: representatives,
        topic: emailTopic,
        phoneNumber: values.Phone,

        address: address
    };

    return api.post('Widget/SendEmailAsync', request).then(response => {
        let isValid = false;
        for (let i = 0; i < response.emailStatusList.length; i++) {
            if (response.emailStatusList[i].status < 2) {
                isValid = true;
            }
        }
        return isValid ? response : Promise.reject(getErrorMessage(response.errorList));
    });
};

export default completeEmail;
